// extracted by mini-css-extract-plugin
export default {"modal":"sso-whitelist-type-modal_modal__jlAno","content":"sso-whitelist-type-modal_content__ULXxX"};